/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import { computeWeightNotAbs, computeWeights } from '@/utils/query';

import { LoadingQuery } from '../Tables/Filter';
import { crudRequestGet, crudRequest, getInventory, getInventoryDetail } from '@/services/api';
import { getData_Vehicle2 } from '@/components/report/service';
import { getVolume } from '@/utils';
import lodash from 'lodash';
import moment from 'moment';

// eslint-disable-next-line no-unused-vars

const filterInHouseWeightAndInHouerVolume = (record = {}, data = [], name = '') => {
  // 获取查询分拨的名称简称
  const locationName = name.replaceAll(/(分拨中心|经营本部|省区|营运区|管理区)/g, '');
  let shipmentNameList = record.shipmentName.split('-') || [];
  // 获取查询分拨所在的位置
  let locationIndex = shipmentNameList.findIndex((item) => item.includes(locationName));
  // 除了两地卸，都用目的分拨
  const obj =
    data.find((item3) => record.siteName === (item3.nextSite || item3.planNextSite)) || {};
  let calcWeight = Number(obj?.calcWeight || 0);
  let goodsVolume = Number(obj?.goodsVolume || 0);
  // 两地卸
  if (record.dockModel === '两地卸') {
    // 两地卸查询分拨在第一个
    if (locationIndex === 0 && shipmentNameList.length === 3) {
      const { calcWeight: calcWeight1 = 0, goodsVolume: goodsVolume1 = 0 } =
        data.find((item3) => record.siteName === (item3.nextSite || item3.planNextSite)) || {};
      const { calcWeight: calcWeight2 = 0, goodsVolume: goodsVolume2 = 0 } =
        data.find((item3) => record.destSiteName === (item3.nextSite || item3.planNextSite)) || {};
      calcWeight = Number(calcWeight1) + Number(calcWeight2);
      goodsVolume = Number(goodsVolume1) + Number(goodsVolume2);
      // 两地卸查询分拨在第二个
    } else if (locationIndex === 1 && shipmentNameList.length === 3) {
      calcWeight = 0;
      goodsVolume = 0;
    }
  }
  return {
    calcWeight,
    goodsVolume,
  };
};

/**
 *
 * @param {* 交接单信息集合} filteredData
 * @param {* 在装数据 } loadingData
 * @returns
 */
const filterPendingData = (filteredData = new Map(), loadingData = []) => {
  // 在装数据
  let loadingList = [...loadingData];
  // 待发数据
  let pendingList = [];
  for (let i = 0; i < loadingData.length; i++) {
    const item = loadingData[i];
    // 交接单号详情
    const deliveryReceiptNoDetails = filteredData.get(item.taskNo) || [];
    // pda交接时间都存在 并且 不是系统默认时间
    const isAllExist =
      deliveryReceiptNoDetails &&
      deliveryReceiptNoDetails.every(
        (item) => item.receiptTime && item.receiptTime !== '2000-01-01 00:00:00',
      );
    if (isAllExist) {
      // 取出deliveryReceiptNoDetails，时间较晚的对象
      let latestItem;
      let latestTime = null;
      for (const detail of deliveryReceiptNoDetails) {
        const receiptTime = moment(detail.receiptTime);
        if (!latestTime || receiptTime.isAfter(latestTime)) {
          latestTime = receiptTime;
          latestItem = detail;
        }
      }
      // pda时间交接时间存在 & 发车时间不存在 就是待发
      if (latestItem) {
        pendingList.push({
          ...latestItem,
          receiptTime: latestItem.receiptTime,
          receiptTimeTimestamp: latestItem.receiptTime
            ? moment(latestItem.receiptTime).valueOf()
            : 0,
        });
      }
    }
  }
  loadingList = loadingList.filter(
    (item) => !pendingList.some((value) => value.taskNo === item.taskNo),
  );

  const _filteredData = loadingList.filter((item) => item.inHouerVolume === 0);
  console.log(
    '%c [ loadingList models 在装数据-inHouerVolume 为0 ]: ',
    'color: #bf2c9f; background: pink; font-size: 13px;',
    _filteredData,
  );
  return {
    pendingList,
    loadingList,
  };
};

export default {
  namespace: 'vehicleMonitoringNewLoading',
  state: {
    loadingAllList: [],

    loadingList: [], // 在装
    loadedList: [], // 待装
    pendingList: [], // 待发
    loadedTotalModalVisible: false, // 已装合计弹窗
    lineData: null,

    lineInStockData: null, // 库存明细行
    productInStockCalc: [], // 库存产品结算重量
    productInStockTicket: [], // 库存产品票数
    // inStockModalVisible: false,  //库存弹窗显隐
    pendingFilter: 'all',
    inStockPDAStatus: {}, // 在装 PDA 状态
  },
  effects: {
    *getLoadingData(_, { call, put, select }) {
      console.log('========= 开始获取在装数据 getLoadingData (New) =========');
      let query = yield select(({ vehicleMonitoringNew }) => {
        // 模拟重复车辆
        // vehicleMonitoringNew.planDepartureCarsItem.push({
        //   ...vehicleMonitoringNew.planDepartureCarsItem.find(m => m.taskNo === 'SHY20220104114'), // 取现有列表中运输凭单号
        //   planTime: '2022-01-02 15:53:32'
        // })
        //#region 去重,保留 planTime计划发车时间在前面(小)的
        // 克隆新数组与新对象，避免原地 sort 及后续修改污染 state 引用
        let planDepartureCarsItem = (vehicleMonitoringNew.planDepartureCarsItem || [])
          .map((item) => ({ ...item }))
          .sort((f, l) => {
            const compart = moment(f.planTime).valueOf() - moment(l.planTime).valueOf();
            return compart;
          });
        planDepartureCarsItem = lodash.uniqWith(
          planDepartureCarsItem,
          (f, l) => f.taskNo === l.taskNo,
        );
        //#endregion

        return {
          /** 计划发出 */
          planDepartureCarsItem: planDepartureCarsItem,
          volumeItem: vehicleMonitoringNew.volumeItem,
          centerFilter: vehicleMonitoringNew.centerFilter,
          startDate: moment(vehicleMonitoringNew.dateRange2[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endDate: moment(vehicleMonitoringNew.dateRange2[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
        };
      });

      console.log('getLoadingData (New) - 获取到初始数据:', {
        centerFilter: query.centerFilter,
        startDate: query.startDate,
        endDate: query.endDate,
        planDepartureCarsItemCount: query.planDepartureCarsItem?.length || 0,
      });

      if (query.planDepartureCarsItem.length > 0) {
        const taskNos = query.planDepartureCarsItem.map((item) => item.taskNo);
        const nextSiteCodes = [
          ...query.planDepartureCarsItem.map((item) => item.siteCode),
          ...query.planDepartureCarsItem.map((item) => item.destSiteCode),
        ];

        console.log('getLoadingData (New) - 准备调用 LoadingQuery:', {
          taskNosCount: taskNos.length,
          nextSiteCodesCount: nextSiteCodes.length,
          sampleTaskNo: taskNos.length > 0 ? taskNos[0] : '无',
          sampleNextSiteCode: nextSiteCodes.length > 0 ? nextSiteCodes[0] : '无',
        });

        const filter = LoadingQuery({
          scanSiteCode: query.centerFilter?.code,
          scanSite: query.centerFilter?.name,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: taskNos,
          nextSiteCodes: nextSiteCodes,
        });

        console.log('getLoadingData (New) - 调用 LoadingQuery 后获取到查询条件:', {
          filterLength: filter.length,
          filter0Remark: filter[0]?.remark || '无备注',
          filter2Remark: filter[2]?.remark || '无备注',
          filter2AndFilters: filter[2]?.andFilters || '无andFilters',
          filter2InFilters: filter[2]?.inFilters || '无inFilters',
        });

        const results = [];
        for (let i = 0; i < filter.length; i++) {
          console.log(
            `getLoadingData (New) - 开始调用 getData_Vehicle2 获取数据, 查询条件索引: ${i}`,
          );
          const d = yield call(getData_Vehicle2, filter[i], {}, 'druid2');
          results.push(d || []);
          console.log(
            `getLoadingData (New) - 获取到数据, 查询条件索引: ${i}, 结果数量: ${d?.length || 0}`,
          );
        }

        console.log('getLoadingData (New) - 获取到的所有数据结果:', {
          results0Count: results[0]?.length || 0,
          results1Count: results[1]?.length || 0,
          results2Count: results[2]?.length || 0, // 这是在装-库存-装车
          results3Count: results[3]?.length || 0, // 这是在装-库存-卸车
        });

        // 定时达,库存,装载率分组
        query.planDepartureCarsItem.forEach((item) => {
          const carTypeName = item.carTypeName?.replace('米', '');
          item.toTalVolume = carTypeName && getVolume[carTypeName];
          results.forEach((item2, index2) => {
            let obj;
            switch (index2) {
              case 0:
                let filter = item2.filter((item3) => item.taskNo === item3.taskNo);
                if (filter.length) {
                  obj = { calcWeight: 0, goodsVolume: 0, deliveryReceiptNo: '' };
                }
                filter.forEach((item) => {
                  obj.calcWeight += Number(item?.calcWeight) || 0;
                  obj.goodsVolume += Number(item?.goodsVolume) || 0;
                  obj.deliveryReceiptNo += item?.deliveryReceiptNo + '\n';
                });
                item[`calcWeight${index2}`] = obj ? Number(obj.calcWeight) : 0;
                // item[`goodsVolume${index2}`] = obj ? obj.goodsVolume : 0;
                item[`unloadVolume${index2}`] = obj
                  ? Math.abs(Number(obj.goodsVolume)?.toFixed(1))
                  : 0;
                item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo?.trim() : '';
                break;
              case 1:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = obj ? Number(obj.calcWeight) : 0;
                item[`goodsVolume${index2}`] = obj ? Number(obj.goodsVolume) : 0;
                item[`unloadVolume${index2}`] = obj
                  ? Math.abs(Number(obj.goodsVolume)?.toFixed(1))
                  : 0;
                if (index2 === 0) item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo : '';
                break;
              case 2:
              case 3:
                const { calcWeight, goodsVolume } = filterInHouseWeightAndInHouerVolume(
                  item,
                  item2,
                  query.centerFilter?.name,
                );
                item[`calcWeight${index2}`] = Number(calcWeight);
                item[`goodsVolume${index2}`] = Number(goodsVolume);
                break;
              case 4:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = obj ? Number(obj.calcWeight) : 0;
                item[`goodsWeight${index2}`] = obj ? Number(obj.goodsWeight) : 0;
              default:
                break;
            }
          });
          item.planTime2 = item.planTime ? moment(item.planTime).format('MM/DD HH:mm') : '--';
        });
        // 计算
        query.planDepartureCarsItem.forEach((item, index) => {
          item.index = index;
          // 本站已装合计
          item.totalWeight = computeWeights(Number(item.calcWeight0));
          // 本站已装定时达
          item.timeWeight = computeWeights(Number(item.calcWeight1));
          const calcWeight4 = computeWeights(Number(item.calcWeight4)); // 车辆已装货量: 可能还有发往下一站没有卸车的
          const goodsWeight4 = computeWeights(Number(item.goodsWeight4)); // 车辆已装货量: 可能还有发往下一站没有卸车的
          // 剩余可用运力   总运力-车辆已装货量
          item.volume =
            item.toTalVolume &&
            parseFloat((Number(item.toTalVolume) - Number(goodsWeight4)).toFixed(1));
          // 装载率(车辆已装货量)/总运力
          item.rateVolume = item.toTalVolume
            ? ((Number(calcWeight4) / Number(item.toTalVolume)) * 100).toFixed(1)
            : '';
          // 在库
          item.inHouseWeight = computeWeights(Number(item.calcWeight2) + Number(item.calcWeight3));
          item.inHouerVolume = Number.parseFloat(
            Math.abs((Number(item.goodsVolume2) || 0) + (Number(item.goodsVolume3) || 0)).toFixed(
              1,
            ),
          );
          item.planTimeTimestamp = item.planTime ? moment(item.planTime).valueOf() : 0;
        });
      }
      console.log('getLoadingData (New) - 数据处理完成, 准备更新状态');
      yield put({
        type: 'update',
        payload: {
          loadingAllList: query.planDepartureCarsItem,
        },
      });
      yield put({ type: 'getTimes' });
      console.log('========= 结束获取在装数据 getLoadingData (New) =========');
    },
    // 在装和待发
    *getTimes(_, { put, select }) {
      // 获取时间差
      const { loadingAllList } = yield select(
        ({ vehicleMonitoringNewLoading }) => vehicleMonitoringNewLoading,
      );

      // 克隆新数组与新对象，避免直接修改 state 引用导致视图不刷新
      const newLoadingAllList = (loadingAllList || []).map((item) =>
        item && typeof item === 'object' ? { ...item } : item,
      );

      let loadingData = []; // 在装
      let pendingData = []; // 待发
      if (newLoadingAllList.length > 0) {
        for (let i = 0; i < newLoadingAllList.length; i++) {
          const now = moment(new Date()); // 当前时间
          const time = moment(newLoadingAllList[i].planTime); // 预计发车时间
          if (now.valueOf() === time.valueOf()) {
            newLoadingAllList[i] = '已出发';
            break;
          }
          const dur = time - now;
          let tempTime = moment.duration(dur);
          const _days = tempTime.days();
          const _hours = tempTime.hours();
          const _minutes = tempTime.minutes();
          const days = _days !== 0 ? Math.abs(_days) : null;
          const hours = Math.abs(_hours);
          const minutes = Math.abs(_minutes);

          let durTime = '';
          if (_days < 0 || _hours < 0 || _minutes < 0) {
            durTime = '延误:';
          }
          durTime += `${days ? days + '天' : ''}${hours ? hours + '小时' : ''}${
            minutes ? minutes + '分' : ''
          }`;
          newLoadingAllList[i].durTime = durTime;
        }
        loadingData = newLoadingAllList.filter((item) => item.deliveryReceiptNo);
      }
      // deliveryReceiptNo交接单号存在可能是 待发 或 在装
      if (loadingData && loadingData.length > 0) {
        // 获取交接单号
        let numberList = [];
        const list = loadingData.map((v) => v.deliveryReceiptNo);
        list.forEach((item) => {
          const splitItems = item.split('\n');
          numberList = numberList.concat(splitItems);
        });

        const filteredData = new Map();
        const preeCount = 40; // 每次请求交接单信息条数

        // 分批量查询接单号详情
        for (let first = 0; first < numberList.length; first += preeCount) {
          let last = first + preeCount;
          if (last > numberList.length) last = numberList.length;
          const deliverList = numberList.slice(first, last);
          const result = yield crudRequestGet(
            `/api/v1/track/receipt/infoDetail?deliveryNoList=${deliverList.toString()}`,
            { module: 'maxcenterbusi' },
          );
          if (result && result?.data.length > 0) {
            // 查询的交接单号根据运输凭单号taskNo分组
            result.data.forEach((item) => {
              const { taskNo } = item;
              if (!filteredData.has(taskNo)) {
                filteredData.set(taskNo, []);
              }
              const obj = loadingData.find((item) => item.taskNo === taskNo);
              filteredData.get(taskNo).push({ ...item, ...obj });
            });
          }
        }
        const { loadingList, pendingList } = filterPendingData(filteredData, loadingData);
        loadingData = loadingList;
        pendingData = pendingList;
      }

      // 获取在装 PDA 状态
      let siteCode = yield select(
        ({ vehicleMonitoringNew }) => vehicleMonitoringNew?.centerFilter?.code,
      );
      const resData = yield crudRequest(`/api/route/selectLoadPDA`, {
        siteCode,
        taskNos: loadingData.map((item) => item.taskNo),
      });
      if (resData?.code === 1) {
        let inStockPDAStatus = {};
        resData?.data?.forEach((item) => {
          inStockPDAStatus[item.taskNo] = item;
        });
        loadingData.forEach((item) => {
          item.pdaStatus = inStockPDAStatus?.[item.taskNo]?.pdaStatus;
        });
      }
      // 获取在装。在装(T/F) 的数据
      const InventoryQuery = yield select(({ vehicleMonitoringNew }) => {
        return {
          locationCode: vehicleMonitoringNew.centerFilter.code,
          locationName: vehicleMonitoringNew.centerFilter.name,
          startTime: moment(vehicleMonitoringNew.dateRange2[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endTime: moment(vehicleMonitoringNew.dateRange2[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          taskNos: loadingData.map((item) => item.taskNo),
          // taskNos: ['X202511251482'],
        };
      });
      const { data: inventoryData = [] } = yield getInventory(InventoryQuery);
      console.log(inventoryData, 'inventoryData loadingData');
      console.log(loadingData, 'loadingData inventoryData');
      // 根据查询出来的inventoryData 更新 loadingData 里面的 inHouseWeight 和 inHouerVolume
      if (inventoryData && inventoryData.length > 0) {
        // 使用 lodash.keyBy 将 inventoryData 转换为以 taskNo 为 key 的映射，查找时间复杂度 O(1)
        const inventoryMap = lodash.keyBy(inventoryData, 'taskNo');
        loadingData.forEach((item) => {
          const inventory = inventoryMap[item.taskNo];
          if (inventory) {
            item.inHouseWeight = Number(inventory.calcWeight) || 0;
            item.inHouerVolume = Number(inventory.calcVolume) || 0;
          }
        });
      }
      // 获取在装 PDA 状态 结束
      yield put({
        type: 'update',
        payload: {
          loadingList: loadingData,
          pendingList: pendingData,
        },
      });
    },
    // 在装在库详情
    *getInStockDetail({ payload: { lineInStockData } }, { put, select }) {
      yield put({ type: 'update', payload: { lineInStockData } });

      // 调用库存明细接口，参数和 getInventory 一致，taskNos 传单个单号
      const params = yield select(({ vehicleMonitoringNew }) => {
        return {
          locationCode: vehicleMonitoringNew.centerFilter.code,
          locationName: vehicleMonitoringNew.centerFilter.name,
          startTime: moment(vehicleMonitoringNew.dateRange2[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endTime: moment(vehicleMonitoringNew.dateRange2[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          taskNos: [lineInStockData?.taskNo],
        };
      });

      const { data: inventoryDetailData = [] } = yield getInventoryDetail(params);

      // 产品类型重量和票数
      const productInStockCalc = [];
      const productInStockTicket = [];

      if (inventoryDetailData && inventoryDetailData.length > 0) {
        inventoryDetailData.forEach((item) => {
          // 接口返回的 calcWeight 已经是吨，不需要再转换
          const calcWeight = Number.parseFloat(item.calcWeight) || 0;
          if (calcWeight > 0.01) {
            productInStockCalc.push({ name: item.productType, value: calcWeight });
          }
          // 接口返回的是 piece 字段
          const piece = Number.parseFloat(item.ticket) || 0;
          if (piece > 0) {
            productInStockTicket.push({ name: item.productType, value: piece });
          }
        });
      }

      yield put({ type: 'update', payload: { productInStockCalc, productInStockTicket } });
    },
    // 待装
    *getLoadedData(_, { call, put, select }) {
      console.log('========= 开始获取待装数据 getLoadedData (New) =========');
      let query = yield select(({ vehicleMonitoringNew }) => {
        // 克隆新数组与新对象，避免原地 sort 及后续修改污染 state 引用
        let loadedItem = (vehicleMonitoringNew.loadedItem || [])
          .map((item) => ({ ...item }))
          .sort((f, l) => {
            const compart = moment(f.planTime).valueOf() - moment(l.planTime).valueOf();
            return compart;
          });
        loadedItem = lodash.uniqWith(loadedItem, (f, l) => f.taskNo === l.taskNo);
        //#endregion
        return {
          /** 计划发出 */
          loadedItem: loadedItem,
          centerFilter: vehicleMonitoringNew.centerFilter,
          startDate: moment(vehicleMonitoringNew.dateRange3[0]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          endDate: moment(vehicleMonitoringNew.dateRange3[1]).format(
            vehicleMonitoringNew.defualtDateFormat,
          ),
          isOnlyShow: vehicleMonitoringNew.isOnlyShow,
        };
      });

      console.log('getLoadedData (New) - 获取到初始数据:', {
        centerFilter: query.centerFilter,
        startDate: query.startDate,
        endDate: query.endDate,
        loadedItemCount: query.loadedItem?.length || 0,
      });

      if (query.loadedItem.length > 0) {
        const taskNos = query.loadedItem.map((item) => item.taskNo);

        console.log('getLoadedData (New) - 准备调用 LoadingQuery:', {
          taskNosCount: taskNos.length,
          nextSiteCodes: '[]', // 注意这里传入空数组
          sampleTaskNo: taskNos.length > 0 ? taskNos[0] : '无',
        });

        const filter = LoadingQuery({
          scanSiteCode: query.centerFilter?.code,
          scanSite: query.centerFilter?.name,
          startDate: query.startDate,
          endDate: query.endDate,
          taskNos: taskNos,
          nextSiteCodes: [],
        });

        console.log('getLoadedData (New) - 调用 LoadingQuery 后获取到查询条件:', {
          filterLength: filter.length,
          filter0Remark: filter[0]?.remark || '无备注',
          filter2Remark: filter[2]?.remark || '无备注',
          filter2AndFilters: filter[2]?.andFilters || '无andFilters',
          filter2InFilters: filter[2]?.inFilters || '无inFilters',
        });

        const results = [];
        for (let i = 0; i < filter.length; i++) {
          console.log(
            `getLoadedData (New) - 开始调用 getData_Vehicle2 获取数据, 查询条件索引: ${i}`,
          );
          const d = yield call(getData_Vehicle2, filter[i], {}, 'druid2');
          results.push(d || []);
          console.log(
            `getLoadedData (New) - 获取到数据, 查询条件索引: ${i}, 结果数量: ${d?.length || 0}`,
          );
        }

        console.log('getLoadedData (New) - 获取到的所有数据结果:', {
          results0Count: results[0]?.length || 0,
          results1Count: results[1]?.length || 0,
          results2Count: results[2]?.length || 0, // 这是待装-库存-装车
          results3Count: results[3]?.length || 0, // 这是待装-库存-卸车
        });

        // 定时达,库存,装载率分组
        query.loadedItem.forEach((item) => {
          const carTypeName = item.carTypeName?.replace('米', '');
          item.toTalVolume = carTypeName && getVolume[carTypeName];
          results.forEach((item2, index2) => {
            let obj;
            switch (index2) {
              case 0:
                let filter = item2.filter((item3) => item.taskNo === item3.taskNo);
                if (filter.length) {
                  obj = { calcWeight: 0, goodsVolume: 0, deliveryReceiptNo: '' };
                }
                filter.forEach((item3) => {
                  obj.calcWeight += Number(item3?.calcWeight) || 0;
                  obj.goodsVolume += Number(item3?.goodsVolume) || 0;
                  obj.deliveryReceiptNo += item3?.deliveryReceiptNo + '\n';
                });
                item[`calcWeight${index2}`] = obj ? Number(obj.calcWeight) : 0;
                // item[`goodsVolume${index2}`] = obj ? obj.goodsVolume : 0;
                item[`unloadVolume${index2}`] = obj
                  ? Math.abs(Number(obj.goodsVolume)?.toFixed(1))
                  : 0;
                item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo?.trim() : '';
                break;
              case 1:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = Number(obj?.calcWeight) || 0;
                item[`goodsVolume${index2}`] = Number(obj?.goodsVolume) || 0;
                item[`unloadVolume${index2}`] = Number(obj?.goodsVolume)
                  ? Math.abs(Number(obj.goodsVolume).toFixed(1))
                  : 0;
                if (index2 === 0) item.deliveryReceiptNo = obj ? obj.deliveryReceiptNo : '';
                break;
              case 2:
              case 3:
                const { calcWeight, goodsVolume } = filterInHouseWeightAndInHouerVolume(
                  item,
                  item2,
                  query.centerFilter?.name,
                );
                item[`calcWeight${index2}`] = Number(calcWeight) || 0;
                item[`goodsVolume${index2}`] = Number(goodsVolume) || 0;
                break;
              case 4:
                obj = item2.find((item3) => item.taskNo === item3.taskNo);
                item[`calcWeight${index2}`] = Number(obj?.calcWeight) || 0;
                item[`goodsWeight${index2}`] = Number(obj?.goodsWeight) || 0;
              default:
                break;
            }
          });
          item.planTime2 = item.planTime ? moment(item.planTime).format('MM/DD HH:mm') : '--';
        });

        // 计算
        query.loadedItem.forEach((item, index) => {
          item.index = index;
          // 本站已装合计
          item.totalWeight = computeWeights(Number(item.calcWeight0));
          // 本站已装定时达
          item.timeWeight = computeWeights(Number(item.calcWeight1));
          const calcWeight4 = computeWeights(Number(item.calcWeight4)); // 车辆已装货量: 可能还有发往下一站没有卸车的
          const goodsWeight4 = computeWeights(Number(item.goodsWeight4)); // 车辆已装货量: 可能还有发往下一站没有卸车的
          // 剩余可用运力   总运力-车辆已装货量
          item.volume =
            item.toTalVolume && Number.parseFloat((item.toTalVolume - goodsWeight4).toFixed(1));
          // 装载率(车辆已装货量)/总运力
          item.rateVolume = item.toTalVolume
            ? ((Number(calcWeight4) / item.toTalVolume) * 100).toFixed(1)
            : '';
          // 在库
          item.inHouseWeight = computeWeights(Number(item.calcWeight2) + Number(item.calcWeight3));
          item.inHouerVolume = Number.parseFloat(
            Math.abs((Number(item.goodsVolume2) || 0) + (Number(item.goodsVolume3) || 0)).toFixed(
              1,
            ),
          );
          item.planTimeTimestamp = item.planTime ? moment(item.planTime).valueOf() : 0;
        });
      }
      let loadedData = [];
      if (query.loadedItem.length > 0) {
        for (let i = 0; i < query.loadedItem.length; i++) {
          const now = moment(new Date()); // 当前时间
          const time = moment(query.loadedItem[i].planTime); // 预计发车时间
          if (now.valueOf() === time.valueOf()) {
            query.loadedItem[i] = '已出发';
            break;
          }
          const dur = time - now;
          let tempTime = moment.duration(dur);
          const _days = tempTime.days();
          const _hours = tempTime.hours();
          const _minutes = tempTime.minutes();
          const days = _days !== 0 ? Math.abs(_days) : null;
          const hours = Math.abs(_hours);
          const minutes = Math.abs(_minutes);

          let durTime = '';
          if (_days < 0 || _hours < 0 || _minutes < 0) {
            durTime = '延误:';
          }
          durTime += `${days ? days + '天' : ''}${hours ? hours + '小时' : ''}${
            minutes ? minutes + '分' : ''
          }`;
          query.loadedItem[i].durTime = durTime;
        }
        loadedData = query.loadedItem
          .filter((item) => !item.deliveryReceiptNo)
          .filter((item) => {
            if (query.isOnlyShow && item.dockModel === '两地卸') {
              const searchName = query?.centerFilter?.name?.replace('分拨中心', '');
              return item.shipmentName.split('-')?.[0] === searchName;
            }
            return true;
          });
      }
      console.log(
        'getLoadedData (New) - 数据处理完成, 准备更新状态, 最终待装数据数量:',
        loadedData.length,
      );
      yield put({
        type: 'update',
        payload: {
          loadedList: loadedData,
        },
      });
      console.log('========= 结束获取待装数据 getLoadedData (New) =========');
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
